import React, { useState } from 'react';
import { PhoneIcon } from 'lucide-react';
import { LeadModal } from '../components/LeadModal';
import { formatCurrency, queue, type Lead } from '../data/mockData';
const followUps = queue.filter(lead => lead.detail.startsWith('Follow-up'));
export function FollowUps() {
  const [selected, setSelected] = useState<Lead | null>(null);
  return <div className="space-y-4" data-id="element-256" data-mp="s8gp13s8ssz0">
      <div data-id="element-257" data-mp="dgy54uw9iead">
        <h1 className="text-[22px] font-bold text-ink" data-id="element-258" data-mp="dh7ssbtu49cw">Follow-ups</h1>
        <p className="mt-1 text-[13px] text-gray-500" data-id="element-259" data-mp="i86gvxl2ebqp">
          7 due today · <span className="font-semibold text-danger" data-id="element-260" data-mp="i9hknxeifjht">1 overdue</span>
        </p>
      </div>

      <ul className="space-y-3" data-id="element-261" data-mp="4imh90ms5ulm">
        {followUps.map(lead => <li key={lead.id} className="flex flex-wrap items-center gap-3 rounded-xl border border-gray-200 bg-white px-5 py-4" data-id="element-262" data-mp="9gxor4plrt0o">
            <button type="button" onClick={() => setSelected(lead)} className="min-w-0 flex-1 text-left focus:outline-none" data-id="element-263" data-mp="3vmt9q1iy586c">
              <p className="text-[13.5px] font-semibold text-ink" data-id="element-264" data-mp="1r71dpsj4y4p4">
                {lead.name}{' '}
                <span className="font-normal text-gray-500" data-id="element-265" data-mp="1m8hpflh2kgtl">
                  · {lead.state} · {formatCurrency(lead.amount)}
                </span>
              </p>
              <p className="mt-0.5 text-[12.5px] text-gray-500" data-id="element-266" data-mp="1w4t5mmjs5qtb">{lead.detail}</p>
            </button>
            <button type="button" className="inline-flex items-center gap-2 rounded-lg border border-gray-200 px-3 py-1.5 text-[12.5px] font-medium text-ink transition-colors hover:bg-gray-50" data-id="element-267" data-mp="18f8jxvw8sfgc">
              <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-268" data-mp="1cgc0kkm46fim" />
              Call now
            </button>
          </li>)}
      </ul>

      <LeadModal lead={selected} onClose={() => setSelected(null)} data-id="element-269" data-mp="opogz22u61g8" />
    </div>;
}